
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import InstituteDashboard from './InstituteDashboard';
import '../../assets/css/Institute/Appliedstudents.css';

const Appliedstudents = () => {
    const [appliedForms, setAppliedForms] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [editingId, setEditingId] = useState(null);
    const [editedForm, setEditedForm] = useState({});

    useEffect(() => {
        fetchApplications();
    }, []);

    const fetchApplications = async () => {
        try {
            const res = await axios.get('https://api.myskills.lk/apply/appliedforms');
            if (res.data && Array.isArray(res.data)) {
                setAppliedForms(res.data);
            } else {
                setAppliedForms([]);
            }
        } catch (err) {
            console.error('Error:', err);
            setError('Failed to load data.');
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = (form) => {
        setEditingId(form.id);
        setEditedForm({ ...form });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditedForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleCancel = () => {
        setEditingId(null);
        setEditedForm({});
    };

    const handleSave = async (id) => {
        try {
            await axios.post(`https://api.myskills.lk/apply/update/${id}`, editedForm);
            setAppliedForms((prev) =>
                prev.map((item) => (item.id === id ? editedForm : item))
            );
            handleCancel();
        } catch (err) {
            console.error('Save error:', err);
        }
    };

    const handleDelete = async (id) => {
        try {
            await axios.post(`https://api.myskills.lk/apply/delete/${id}`);
            setAppliedForms((prev) => prev.filter((item) => item.id !== id));
        } catch (err) {
            console.error('Delete error:', err);
        }
    };

    return (
        <div className="min-h-screen bg-gray-100 flex flex-col">
            <InstituteDashboard />
            <div className="flex-grow p-4 md:p-8 max-w-full mx-auto w-full applied-students-main-content">
                <h2 className="text-3xl font-extrabold text-gray-800 mb-6 text-center">Applied Students</h2>

                {loading && <p className="text-center text-lg">Loading...</p>}
                {error && <p className="text-center text-red-500">{error}</p>}
                {!loading && appliedForms.length === 0 && <p className="text-center">No data found.</p>}

                {!loading && appliedForms.length > 0 && (
                    <div className="applied-students-table-wrapper">
                        <table className="min-w-full applied-students-table">
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>Mobile</th>
                                <th>DOB</th>
                                <th>Email</th>
                                <th>Address</th>
                                <th>District</th>
                                <th>Province</th>
                                <th>Level</th>
                                <th>Message</th>
                                <th>Action</th>

                            </tr>
                            </thead>
                            <tbody>
                            {appliedForms.map((form) => (
                                <tr key={form.id}>
                                    <td>
                                        {editingId === form.id ? (
                                            <input name="name" value={editedForm.name} onChange={handleChange} />
                                        ) : (
                                            form.name
                                        )}
                                    </td>
                                    <td>
                                        {editingId === form.id ? (
                                            <input name="mobile" value={editedForm.mobile} onChange={handleChange} />
                                        ) : (
                                            form.mobile
                                        )}
                                    </td>
                                    <td>
                                        {editingId === form.id ? (
                                            <input type="date" name="dob" value={editedForm.dob?.slice(0, 10)} onChange={handleChange} />
                                        ) : (
                                            new Date(form.dob).toLocaleDateString()
                                        )}
                                    </td>
                                    <td>
                                        {editingId === form.id ? (
                                            <input name="email" value={editedForm.email} onChange={handleChange} />
                                        ) : (
                                            form.email
                                        )}
                                    </td>
                                    <td>
                                        {editingId === form.id ? (
                                            <input name="address" value={editedForm.address} onChange={handleChange} />
                                        ) : (
                                            form.address
                                        )}
                                    </td>
                                    <td>
                                        {editingId === form.id ? (
                                            <input name="district" value={editedForm.district} onChange={handleChange} />
                                        ) : (
                                            form.district
                                        )}
                                    </td>
                                    <td>
                                        {editingId === form.id ? (
                                            <input name="province" value={editedForm.province} onChange={handleChange} />
                                        ) : (
                                            form.province
                                        )}
                                    </td>
                                    <td>
                                        {editingId === form.id ? (
                                            <input name="levelOfStudy" value={editedForm.levelOfStudy} onChange={handleChange} />
                                        ) : (
                                            form.levelOfStudy
                                        )}
                                    </td>
                                    <td className="message-column">
                                        {editingId === form.id ? (
                                            <textarea name="message" value={editedForm.message} onChange={handleChange} />
                                        ) : (
                                            form.message
                                        )}
                                    </td>
                                    <td className="action-buttons">
                                        {editingId === form.id ? (
                                            <>
                                                <button className="save" onClick={() => handleSave(form.id)}>Save</button>
                                                <button className="cancel" onClick={handleCancel}>Cancel</button>
                                            </>
                                        ) : (
                                            <>
                                                <button className="edit" onClick={() => handleEdit(form)}>Edit</button>
                                                <button className="delete" onClick={() => handleDelete(form.id)}>Delete</button>
                                            </>
                                        )}
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Appliedstudents;




